import { common, authError } from '../../../modules/error';

/**
 * ポップアップ認証（SAML SSO のログイン・再認証）で発生するエラーの文言（#3214）。
 * 汎用メッセージだとユーザーが原因（ブロック / 中断）に気付けず操作をやり直せないため個別に用意する。
 */
const popupAuthError = {
  popupBlocked:
    'ポップアップがブロックされました。ブラウザのポップアップブロックを解除してから、もう一度お試しください。',
  popupClosedByUser:
    'ID プロバイダの認証画面が閉じられたため、認証を完了できませんでした。もう一度お試しください。',
  cancelledPopupRequest:
    '認証がキャンセルされました。ボタンを続けて押さずにもう一度お試しください。',
};

/**
 * 二要素認証（MFA）で発生するエラーの文言（#3282）。
 * 汎用メッセージだとユーザーが原因（コード誤り / 期限切れ）に気付けず操作をやり直せない。
 */
const mfaAuthError = {
  invalidVerificationCode:
    '確認コードが正しくありません。認証アプリに表示されている最新のコードを入力してください。',
  sessionExpired: '認証の有効期限が切れました。お手数ですが、最初からやり直してください。',
};

export const getErrorMessageFromAuthErrorCode = (authErrorCode: string): string => {
  switch (authErrorCode) {
    case 'auth/too-many-requests':
      return authError.tooManyRequests;
    case 'auth/invalid-email':
      return authError.invalidEmail;
    case 'auth/user-not-found':
    case 'auth/invalid-uid':
      return authError.userNotFound;
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
      return authError.invalidCredential;
    case 'auth/network-request-failed':
      return authError.networkRequestFailed;
    case 'auth/user-disabled':
      return authError.userDisabled;
    case 'auth/operation-not-allowed':
      return authError.operationNotAllowed;
    // SSO（SAML）の設定不備で発生する。default の汎用メッセージだと原因が分からず
    // 切り分けに時間がかかるため個別にマッピングする（#3166）
    case 'auth/unauthorized-domain':
      return authError.unauthorizedDomain;
    // SSO（SAML）のポップアップ認証で発生する。原因と対処が分かる文言に個別マッピングする（#3214）
    case 'auth/popup-blocked':
      return popupAuthError.popupBlocked;
    case 'auth/popup-closed-by-user':
      return popupAuthError.popupClosedByUser;
    case 'auth/cancelled-popup-request':
      return popupAuthError.cancelledPopupRequest;
    // 二要素認証の確認コード誤り。default の汎用メッセージだと入力し直せば
    // よいことが分からないため個別にマッピングする（#3282）
    case 'auth/invalid-verification-code':
      return mfaAuthError.invalidVerificationCode;
    // 第二要素の解決前に有効期限が切れた場合。コードを入れ直しても解消しないため
    // 操作のやり直しへ誘導する（#3282）
    case 'auth/totp-challenge-timeout':
    case 'auth/invalid-multi-factor-session':
    case 'auth/missing-multi-factor-session':
      return mfaAuthError.sessionExpired;
    default:
      return common;
  }
};
